import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingCoopUnlockLevel } from "../../balancingSelectors/selectBalancingConstants";
import { CoopConstants } from "../../constants/CoopConstants";
import { IdStyles } from "../../less/IdStyles";
import { selectCoopShowNotification, selectIsCoopAvailable } from "../../selectors/selectCoopInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { Badge } from "../generic/badge/Badge";
import { IdBadgePosition } from "../generic/badge/IdBadgePosition";
import { ButtonNormalSmall } from "../generic/common/ButtonNormalSmall";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
import { actionCoopHudClicked } from "./actionCoop";
import { HudButtonCooperativeFlag } from "./HudButtonCooperativeFlag";
var _HudButtonCooperative = function (_a) {
    var coopNotification = _a.coopNotification, onCooperativeMenuOpen = _a.onCooperativeMenuOpen, isCoopAvailable = _a.isCoopAvailable, unreadChatMessages = _a.unreadChatMessages;
    var notificationBadge = coopNotification ? (React.createElement(Badge, { position: IdBadgePosition.TopLeft },
        React.createElement(Icon, { styleId: IdStyles.IconSmall, icon: IdIcon.QuestUpdateIcn }))) : (undefined);
    var chatNotificationBadge;
    if (unreadChatMessages !== 0) {
        var chatMessagesAmount = unreadChatMessages > CoopConstants.MaxChatUnreadMessageCount ? (React.createElement(NumberFormat, { className: IdStyles.TextSmallSecondary, amount: CoopConstants.MaxChatUnreadMessageCount, format: TypeNumberFormat.Add })) : (React.createElement(NumberFormat, { className: IdStyles.TextSmallSecondary, amount: unreadChatMessages }));
        chatNotificationBadge = (React.createElement(Badge, { position: IdBadgePosition.TopRight },
            React.createElement(Icon, { styleId: IdStyles.IconMedium, icon: IdIcon.ChatUpdateIcn },
                React.createElement("div", { className: "chat-hud-icon" }, chatMessagesAmount))));
    }
    var coopClassName = IdStyles.Empty;
    var locaText = IdLoca.cooperative;
    var replacements = new Map();
    if (!isCoopAvailable) {
        coopClassName = IdStyles.StateLocked;
        locaText = IdLoca.floatingText_levelCap;
        replacements.set(ReplacementLoca.zero_0, utilNumber.format(selectBalancingCoopUnlockLevel()));
    }
    return (React.createElement("div", { className: "pos-rel" },
        React.createElement(HudButtonCooperativeFlag, null),
        React.createElement(TooltipText, { id: locaText, anchor: IdTooltipAnchor.BottomLeft, replacements: replacements },
            React.createElement(ButtonNormalSmall, { onClick: onCooperativeMenuOpen, className: coopClassName },
                React.createElement("div", { className: "flex flex--guts w100 h100" },
                    React.createElement(Icon, { icon: IdIcon.CooperativeIcn, styleId: IdStyles.IconLarge, isLocked: !isCoopAvailable }),
                    notificationBadge,
                    chatNotificationBadge)))));
};
var mapDispatch = function (dispatch) { return ({
    onCooperativeMenuOpen: function () {
        dispatch(actionModalOpen(IdModal.Coop));
        dispatch(actionCoopHudClicked());
    },
}); };
var mapState = function (state) { return ({
    coopNotification: selectCoopShowNotification(state),
    isCoopAvailable: selectIsCoopAvailable(state),
    unreadChatMessages: state.chatInfo.unreadMessages,
}); };
export var HudButtonCooperative = connect(mapState, mapDispatch)(_HudButtonCooperative);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/HudButtonCooperative.tsx
// module id = 2266
// module chunks = 3